import { Card, Tooltip } from "antd";
import React from "react";

const DashboardCard = ({ title = "", value = "", icon }) => {
  return (
    <Tooltip title={title} placement="top">
      <Card title={title}>
        <div className="d-flex">
          <div className="w-75">
            <p className="fw-bold">{value}</p>
          </div>
          <div className="w-25 d-flex justify-content-center">{icon}</div>
        </div>
      </Card>
    </Tooltip>
  );
};

export default DashboardCard;
